import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Transportation = () => {
  const show = true;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="Transportation | ICSI 2023" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        <EmptyTwo>
          <div className="entry-content">


            <h2>Transportation facilities in Shenzhen</h2>
            <br></br>



            <h3>Shenzhen Bao&apos;an International Airport</h3>
            <br />

            <p>
              <div className="title-center"
              >
                <img
                  src="./images/transportation/baoan.jpg"
                  width={800}
                />

              </div>
            </p>
            <br />
            <p>
              Shenzhen Bao&apos;an International Airport is located on the east bank of the Pearl River. The airport is 32 kilometers away from the downtown. It is a modern large-scale international airport that integrates sea, land, air, and rail transport in China.<br></br>


              Shenzhen Bao&apos;an International Airport opened in October 1991. Since then, the number of both passenger and cargo traffic has maintained rapid growth.In 2003, its annual passenger throughputexceeded 10 million as a milestone, which enabled Shenzhen Airport to become one of the world&apos;s top 100 airports. In 2007, the annual throughput of passengers exceeded 20 million, making the airport one of the world&apos;s busiest airports. In 2013, the annual passenger throughput exceeded 30 million. In 2016, the annual passenger throughput exceeded 40 million, with a growth of 10 million in only 3 years.
            </p>

            <p>
              For more information, please visit{" "}
              <a href="https://www.szairport.com/szairport/index.shtml">https://www.szairport.com/szairport/index.shtml</a>
            </p>

            <p>&nbsp;</p>
            <h3>Shenzhen North Railway Station</h3>
            <br />
            <div className="title-center">
              <img
                src="./images/transportation/shenzhenbei.jpg"
                width={650}
              />

            </div>
            <p>
              <br />
              Shenzhen North Railway Station is one of the four large intercity railway stations of Shenzhen, located in Longhua District. It has 11 platforms and 20 lines. It is an interchange station between the Guangzhou–Shenzhen–Hong Kong Express Rail Link, the Hangzhou–Fuzhou–Shenzhen High-Speed Railway, future Shenzhen–Zhanjiang high-speed railway and the Shenzhen Metro Lines 4, 5 and 6. Construction started in 2007 and was completed in June 2011. The Line 4 platforms opened on 16 June 2011, Line 5 platforms opened on 28 June 2011, CRH platforms opened on 26 December 2011 and Line 6 platforms opened on 18 August 2020.
            </p>

            <p>&nbsp;</p>
            <h3>Shenzhen Railway Station</h3>
            <br />
            <div className="title-center">
              <img
                src="./images/transportation/shenzhen.jpg"
                width={600}
              />

            </div>
            <p>
              <br />
              Shenzhen Railway Station, located in Luohu District, Shenzhen City, Guangdong Province, China, is a first-class station under the jurisdiction of China Railway Guangzhou Bureau Group Co., Ltd. It is also one of the departure and arrival stations of international trains.
            </p>


            <h2>Transportation to the venue</h2>
            <br></br>

            <h5>
            From Shenzhen Bao&apos;an Airport:

            </h5>

            <b>Metro: </b>Take Metro Line 14 to Shajing Station and walk to the hotel or take the bus M397  (approximately 30 minutes).
            <br></br>
          <div className="title-center">

            <img
              src="./images/transportation/way1.png"
              alt="way1"
              width="55%"
              />
            
          </div>
              <br></br>
            <b>
            Taxi/Ride-Hailing Service:    </b>
            Take a taxi or ride-hailing service from the designated pick-up point at the airport to Shenzhen Jinbaihe Hotel (approximately 15 minutes).
            <br></br>
            <br></br>

            <h5>
            From Shenzhen North Railway Station:
            </h5>

           <b>Metro: </b> Take Metro Line 6 to Songgang Checkpoint Station, transfer to Metro Line 11 to Shajing station and walk to the hotel (approximately 80 minutes).
            <br></br>
            <br></br>
          <div className="title-center">

            <img
              src="./images/transportation/way2.png"
              alt="way2"
              width="55%"
            />
            
          </div>
            <br></br>
            <b>Taxi/Ride-Hailing Service:</b> Take a taxi or ride-hailing service from the designated pick-up point at the railway station to Shenzhen Jinbaihe Hotel (approximately 50 minutes).

            <br></br>
            <br></br>
            <h5>
            From Shenzhen Railway Station:

            </h5>

            <b> Metro: </b>Take Metro Line 1 from Luohu Station to Chegongmiao Checkpoint Station, transfer to Metro Line 11 to Shajing and walk to the hotel  (approximately 90 minutes). The roadmap is as shown in the picture.
          <div className="title-center">

            <img
              src="./images/transportation/way3.png"
              alt="way3"
              width="55%"
            />
            
          </div>

            <br></br>
            <b>Taxi/Ride-Hailing Service: </b>Take a taxi or ride-hailing service from the designated pick-up point at the railway station to Shenzhen Jinbaihe Hotel (approximately 60 minutes).
            <br></br>
            <br></br>
            Please note that the above transportation options are for reference only. Actual travel time and routes may vary due to traffic volume, weather,and other factors. It is recommended to check the traffic conditions in advance and plan your travel accordingly. Wishing you a successful conference!



          </div>
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Transportation | ICSI 2023" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        <EmptyTwo>
          <UnderConstruction />
        </EmptyTwo>
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Transportation;
